import React, { Component } from "react";
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import _ from 'lodash';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import config from 'config';
import Button from "components/CustomButton/CustomButton.jsx";
import Card from "components/Card/Card.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { connect } from 'react-redux';
import promotionActions from 'actions/promotion.actions';
import { promotionService } from '../../services/promotion.services';

import moment from 'moment-timezone';

class Promotions extends Component {
  constructor(props) {
    super(props);
    this.props.dispatch(promotionActions.getSettings());

    this.fetchData = this.fetchData.bind(this);
    this.fetchDataWithDebounce = _.debounce(this.fetchData, 1000);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleApplySearch = this.handleApplySearch.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleSendEmailChange = this.handleSendEmailChange.bind(this);
    this.sendCode = this.sendCode.bind(this);

    this.state = {
      submitted: false,
      settings: {
        amount: '',
        type: '$',
        expiry_days: '',
        active: true
      },
      search: '',
      sendEmail: '',
      criteria: {
        limit: config.pageSize,
        offset: 0,
        search: ''
      }
    };
  }

  componentWillUpdate(props) {
    if(props.settings && JSON.stringify(this.props.settings) !== JSON.stringify(props.settings)) {
      let settings = props.settings;
      this.setState({settings: settings});
    }
    if(props.settingsError && !this.props.settingsError) {
      this.props.addNotification({type: 'error', message: props.settingsError});
    }
    if(props.settingsSuccess && !this.props.settingsSuccess) {
      this.props.addNotification({type: 'success', message: 'Promotion settings updated successfully'});
    }
    if(props.codesError && !this.props.codesError) {
      this.props.addNotification({type: 'error', message: props.codesError});
    }
  }

  handleChange(e) {
    const { name, value } = e.target;
    let settings = this.state.settings;
    settings[name] = value;
    this.setState({ settings: settings });
  }

  handleCheckbox = event => {
    let settings = this.state.settings;
    settings.active = !settings.active;
    this.setState({ settings: settings });
  };

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { dispatch } = this.props;
    let data = {
      amount: Number(this.state.settings.amount),
      type: this.state.settings.type,
      expiry_days: Number(this.state.settings.expiry_days),
      active: this.state.settings.active
    };
    dispatch(promotionActions.updateSettings(data));
  }

  fetchData = (state, instance) => {
    let criteria = this.state.criteria;
    if(criteria.limit !== state.pageSize) {
      criteria.limit = state.pageSize;
      criteria['offset'] = 0;
    }
    else {
      criteria['offset'] = Math.ceil(state.page * state.pageSize);
    }
    this.setState({criteria: criteria}, () => {
      this.props.dispatch(promotionActions.getCodes(criteria));
    });
  };

  refetchFromStart() {
    let criteria = this.state.criteria;
    criteria['offset'] = 0;
    this.setState({criteria: criteria}, () => {
      this.props.dispatch(promotionActions.getCodes(criteria));
    });
  }

  handleSearchChange(e) {
    this.setState({ search: e.target.value });
  }

  handleApplySearch() {
    let criteria = this.state.criteria;
    criteria['search'] = this.state.search;
    this.setState({criteria: criteria}, () => this.refetchFromStart());
  }

  handleClearSearch() {
    let criteria = this.state.criteria;
    criteria['search'] = '';
    this.setState({search: '', criteria: criteria}, () => this.refetchFromStart());
  }

  handleSendEmailChange(e) {
    this.setState({ sendEmail: e.target.value });
  }

  sendCode() {
    const email = this.state.sendEmail.trim();
    if(!email) {
      this.props.addNotification({type: 'error', message: 'Please enter an email address'});
      return;
    }
    confirmAlert({
      title: 'Send Promo Code',
      message: 'Send a promo code to ' + email + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            promotionService.issueCode(email)
              .then(data => {
                if(data.emailSent) {
                  this.props.addNotification({type: 'success', message: 'Code sent to ' + email});
                }
                else {
                  this.props.addNotification({type: 'warning', message: 'Code created but email failed — use Resend'});
                }
                this.setState({ sendEmail: '' });
                this.refetchFromStart();
              })
              .catch(err => {
                this.props.addNotification({type: 'error', message: (err && err.error) || 'Failed to send code'});
              });
          }
        },
        {
          label: 'No',
          onClick: () => ''
        }
      ]
    });
  }

  revokeItem = item => {
    confirmAlert({
      title: 'Revoke Promo Code',
      message: 'Are you sure you want to revoke the code for ' + item.original.email + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            promotionService.revokeCode(item.original.id)
              .then(() => {
                this.props.addNotification({type: 'success', message: 'Code revoked'});
                this.refetchFromStart();
              })
              .catch(err => {
                this.props.addNotification({type: 'error', message: (err && err.error) || 'Failed to revoke code'});
              });
          }
        },
        {
          label: 'No',
          onClick: () => ''
        }
      ]
    });
  }

  resendItem = item => {
    confirmAlert({
      title: 'Resend Promo Code',
      message: 'Resend the code to ' + item.original.email + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            promotionService.resendCode(item.original.id)
              .then(() => {
                this.props.addNotification({type: 'success', message: 'Code resent to ' + item.original.email});
                this.refetchFromStart();
              })
              .catch(err => {
                this.props.addNotification({type: 'error', message: (err && err.error) || 'Failed to resend code'});
              });
          }
        },
        {
          label: 'No',
          onClick: () => ''
        }
      ]
    });
  }

  getStatus(code) {
    if(code.redeemed_at) {
      return 'Redeemed';
    }
    if(code.revoked_at) {
      return 'Revoked';
    }
    if(code.expires_at && moment(code.expires_at).isBefore(moment())) {
      return 'Expired';
    }
    return 'Active';
  }

  getReservationNumber(group) {
    if(group && group.reservation_legs && group.reservation_legs.length) {
      return config.formatReservationNumber(group.reservation_legs[0].reservationNumber);
    }
    return '';
  }

  renderFilters() {
    return (
      <Row style={{ marginBottom: 10 }}>
        <Col md={4}>
          <FormGroup>
            <ControlLabel>Search</ControlLabel>
            <FormControl type="text" placeholder="Search email or code" name="search" value={this.state.search} onChange={this.handleSearchChange} />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <ControlLabel style={{ display: 'block' }}>&nbsp;</ControlLabel>
            <Button bsStyle="info" fill onClick={this.handleApplySearch}>Apply</Button>
            <Button bsStyle="default" style={{ marginLeft: 10 }} onClick={this.handleClearSearch}>Clear</Button>
          </FormGroup>
        </Col>
        <Col md={5}>
          <FormGroup>
            <ControlLabel>Send Code</ControlLabel>
            <div style={{ display: 'flex' }}>
              <FormControl type="email" placeholder="Customer email" name="sendEmail" value={this.state.sendEmail} onChange={this.handleSendEmailChange} />
              <Button bsStyle="info" fill style={{ marginLeft: 10, whiteSpace: 'nowrap' }} onClick={this.sendCode}><i className="fa fa-envelope"></i> Send</Button>
            </div>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  render() {
    const { submitted, settings } = this.state;
    const { settingsLoading } = this.props;
    const codes = this.props.codes || [];
    const loading = this.props.codesLoading || false;
    const total = this.props.total || 0;
    const pageCount = Math.ceil(total / this.state.criteria.limit);
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Returning Customer Promotion Settings"
                content={
                  <form name="promotionSettingsForm" onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={3}>
                        <FormGroup>
                          <ControlLabel>Amount</ControlLabel>
                          <FormControl placeholder="Amount" type="number" bsClass="form-control" name="amount" value={settings.amount} onChange={this.handleChange}></FormControl>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <ControlLabel>Type</ControlLabel>
                          <FormControl componentClass="select" bsClass="form-control" name="type" value={settings.type} onChange={this.handleChange}>
                            <option value="$">$</option>
                            <option value="%">%</option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <ControlLabel>Expiry Days</ControlLabel>
                          <FormControl placeholder="Expiry Days" type="number" bsClass="form-control" name="expiry_days" value={settings.expiry_days} onChange={this.handleChange}></FormControl>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <ControlLabel style={{ display: 'block' }}>Active</ControlLabel>
                          <Checkbox
                            number='active'
                            value={settings.active}
                            onChange={this.handleCheckbox.bind(this)}
                            checked={settings.active}
                            label='Enable promotion'
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button bsStyle="info" disabled={settingsLoading} fill type="submit">
                      Update Settings
                    </Button>
                    {settingsLoading && submitted &&
                      <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                title="Promo Codes"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    {/* ctTableFullWidth strips card padding for the edge-to-edge
                        table; the filter bar needs it back */}
                    <div style={{ padding: '5px 15px 0' }}>
                      {this.renderFilters()}
                    </div>
                    <ReactTable
                      columns={[
                        {
                          Header: "Email",
                          accessor: "email"
                        },
                        {
                          Header: "Code",
                          accessor: "code"
                        },
                        {
                          Header: "Amount",
                          accessor: "amount",
                          Cell: row => (
                            <div>{row.original.type === '%' ? row.original.amount + '%' : '$' + Number(row.original.amount).toFixed(2)}</div>
                          )
                        },
                        {
                          Header: "Sent",
                          accessor: "sent_at",
                          Cell: row => (
                            <div>{row.original.sent_at ? moment(row.original.sent_at).format('MM/DD/YY') : ''}</div>
                          )
                        },
                        {
                          Header: "Expires",
                          accessor: "expires_at",
                          Cell: row => (
                            <div>{row.original.expires_at ? moment(row.original.expires_at).format('MM/DD/YY') : ''}</div>
                          )
                        },
                        {
                          Header: "Status",
                          id: "status",
                          Cell: row => (
                            <div>{this.getStatus(row.original)}</div>
                          )
                        },
                        {
                          Header: "Redeemed",
                          accessor: "redeemed_at",
                          Cell: row => (
                            <div>{row.original.redeemed_at ? moment(row.original.redeemed_at).format('MM/DD/YY') : ''}</div>
                          )
                        },
                        {
                          Header: "Reservation",
                          id: "reservation",
                          Cell: row => (
                            <div>{this.getReservationNumber(row.original.reservation_group)}</div>
                          )
                        },
                        {
                          Header: "Actions",
                          width: 120,
                          Cell: row => (
                            <div className="table-actions">
                              <Button bsStyle="danger" disabled={!!(row.original.redeemed_at || row.original.revoked_at)} fill type="button" title="Revoke" onClick={this.revokeItem.bind(this, row)}><i className="fa fa-ban"></i></Button>
                              <Button bsStyle="info" disabled={!!(row.original.redeemed_at || row.original.revoked_at)} fill type="button" title="Resend" onClick={this.resendItem.bind(this, row)}><i className="fa fa-envelope"></i></Button>
                            </div>
                          )
                        },
                      ]}
                      manual
                      data={codes}
                      pages={pageCount} // Display the total number of pages
                      loading={loading} // Display the loading overlay when we need it
                      onFetchData={this.fetchDataWithDebounce}
                      defaultPageSize={this.state.criteria.limit}
                      className="-striped -highlight"
                    />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { settings, loading, error, success } = state.promotionSettings;
  const { items, total, loading: codesLoading, error: codesError } = state.promoCodes;
  return {
    settings,
    settingsLoading: loading,
    settingsError: error,
    settingsSuccess: success,
    codes: items,
    total,
    codesLoading,
    codesError
  };
}

export default connect(mapStateToProps)(Promotions);
